// src/components/Footer.js
import React from "react";
import { Link } from "react-router-dom";
import AdSlot from "./AdSlot";

const TOP_CATS = [
  { slug: "nature-wallpaper",       label: "Nature Wallpapers"    },
  { slug: "4k-wallpaper",           label: "4K Wallpapers"        },
  { slug: "iphone-wallpaper",       label: "iPhone Wallpapers"    },
  { slug: "anime-wallpaper",        label: "Anime Wallpapers"     },
  { slug: "city-wallpaper",         label: "City Wallpapers"      },
  { slug: "abstract-wallpaper",     label: "Abstract Wallpapers"  },
  { slug: "sunset-wallpaper",       label: "Sunset Wallpapers"    },
  { slug: "galaxy-wallpaper",       label: "Galaxy Wallpapers"    },
];

const Footer = () => (
  <footer className="footer">
    <div className="footer__ad">
      <AdSlot type="footer" />
    </div>

    <div className="footer__inner container">
      <div className="footer__brand">
        <Link to="/" className="footer__logo">
          <span className="logo-mark">HI</span>
          <span className="logo-name">Halro Images</span>
        </Link>
        <p className="footer__tagline">
          Millions of free HD wallpapers<br />
          and stock photos. No attribution required.
        </p>
      </div>

      <nav className="footer__nav" aria-label="Footer navigation">
        <div className="footer__col">
          <p className="footer__col-title">Explore</p>
          <Link to="/"           className="footer__link">Discover Photos</Link>
          <Link to="/categories" className="footer__link">All Categories</Link>
          <Link to="/generate"   className="footer__link">✦ AI Generate</Link>
          <Link to="/downloads"  className="footer__link">My Downloads</Link>
        </div>

        <div className="footer__col">
          <p className="footer__col-title">Popular Categories</p>
          {TOP_CATS.slice(0, 4).map(c => (
            <Link key={c.slug} to={`/category/${c.slug}`} className="footer__link">
              {c.label}
            </Link>
          ))}
        </div>

        <div className="footer__col">
          <p className="footer__col-title">More Wallpapers</p>
          {TOP_CATS.slice(4).map(c => (
            <Link key={c.slug} to={`/category/${c.slug}`} className="footer__link">
              {c.label}
            </Link>
          ))}
        </div>

        <div className="footer__col">
          <p className="footer__col-title">Company</p>
          <Link to="/about"   className="footer__link">About Us</Link>
          <Link to="/contact" className="footer__link">Contact Us</Link>
          <Link to="/privacy" className="footer__link">Privacy Policy</Link>
          <a href="https://www.pexels.com/license/" target="_blank"
             rel="noopener noreferrer" className="footer__link">Photo License</a>
        </div>
      </nav>
    </div>

    <div className="footer__bottom container">
      <p className="footer__copy">
        © {new Date().getFullYear()} Halro Images ·
        Free HD Wallpapers & Stock Photos ·{" "}
        <a href="https://www.pexels.com" target="_blank" rel="noopener noreferrer">Pexels</a>
        {" · "}
        <Link to="/privacy">Privacy</Link>
        {" · "}
        <Link to="/contact">Contact</Link>
      </p>
    </div>
  </footer>
);

export default Footer;
